import React from 'react';
import { useServiceLocation } from './ServiceLocationContext';

export default function PropertyPicker() {
  const { locations, setSelected } = useServiceLocation();

  return (
    <div className="min-h-screen flex items-center justify-center bg-slate-950 p-6">
      <div className="w-full max-w-md">
        <h1 className="text-xl font-bold text-white mb-1">Select a Property</h1>
        <p className="text-sm text-slate-400 mb-6">You have multiple properties on file. Choose one to continue.</p>
        <div className="space-y-3">
          {locations.map(loc => (
            <button
              key={loc.name}
              onClick={() => setSelected(loc.name)}
              className="w-full text-left rounded-2xl border border-white/10 bg-slate-900/60 p-4 hover:bg-slate-800/60 transition"
            >
              <p className="font-semibold text-white">{loc.location_name || loc.name}</p>
              <p className="text-sm text-slate-400">{loc.address}</p>
              {!loc.is_active && <p className="text-xs text-amber-400 mt-1">Inactive</p>}
            </button>
          ))}
        </div>
      </div>
    </div>
  );
}
